import { LOADER_STATUS, SET_GSTR9C_HISTORY, SET_SELECTED_ROWS, SET_SELECTED_ROW_DATA, SET_FETCH_PAGINATION } from "./constants";

export const initialState = {
    loaderStatus: false,
    gstr9CHistoryData: [],
    selectedRows: [],
    selectedRowData: [],
    fetchPagination: {
        currentPage: 1,
        pageSize: 10,
        totalRecords: 0
    }
};
  
  
const gstr9CNewFetchReducer = (state = initialState, action) => {
    switch (action.type) {

        case LOADER_STATUS:
            return {
                ...state,
                loaderStatus: action.loaderStatus
            }
        case SET_GSTR9C_HISTORY:
            return {
                ...state,
                gstr9CHistoryData: action.gstr9CHistoryData
            }
        case SET_SELECTED_ROWS:
            return {
                ...state,
                selectedRows: action.selectedRows
            }
        case SET_SELECTED_ROW_DATA:
            return {
                ...state,
                selectedRowData: action.selectedRowData
            }
        case SET_FETCH_PAGINATION:
            return {
                ...state,
                fetchPagination: action.fetchPagination
            }
        default:
            return state;
    }
};
  
  export default gstr9CNewFetchReducer;